import { isMobile } from 'react-device-detect';
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const classNames = (...classes: any) => {
    return classes.filter(Boolean).join(" ");
};
const responsiveClassName = (mobileClassName: string, desktopClassName: string|null) => {
    if (isMobile) {
        return tw`${mobileClassName}`
    } else {
        return tw`${desktopClassName ? desktopClassName : mobileClassName}`
    }

}
export { classNames,responsiveClassName };